export default "__VITE_ASSET__a0c29480__"